import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { TagModel } from "models/TagModel";
import { Image } from "react-bootstrap";
import { images } from "assets/images";
import Label from "../Label/label";

type TagsProps = {
  tags: TagModel[];
  isButton?: boolean;
  className?: string;
  getValues?;
  setValue?;
};

const Labels = (props: TagsProps) => {
  const { t } = useTranslation();
  const { tags, isButton, className, getValues, setValue } = props;
  const [showAll, setShowAll] = useState(false);

  const renderLabels = () => {
    const numToShow = 9;
    const displayedTags = showAll ? tags : tags?.slice(0, numToShow);
    const renderText = showAll ? (
      t("showLess")
    ) : (
      <>
        {t("showMore")}
        <Image
          src={images.leftArrow}
          alt={images.leftArrow}
          className="defualt-padding-horizontal custom-width icon-directional"
        />
      </>
    );
    return (
      <div className={className}>
        {displayedTags?.map((tag: TagModel, index) => {
          return (
            <Label
              key={`${tag.tagCode}_${index + 1}`}
              id={tag.tagCode}
              text={tag.tagName}
              isButton={isButton}
              active={tag.active}
              setValue={setValue}
              getValues={getValues}
            />
          );
        })}
        {tags?.length > numToShow && (
          <button type="button" onClick={() => setShowAll(!showAll)}>
            {renderText}
          </button>
        )}
      </div>
    );
  };

  return <div className="labelsContainer">{renderLabels()}</div>;
};

export default Labels;
